import React, { useState } from 'react';
import { X, Upload, CheckCircle2, ChevronRight } from 'lucide-react';
interface ModalsProps {
  getStartedOpen: boolean;
  resumeReviewOpen: boolean;
  onClose: () => void;
}
export function Modals({
  getStartedOpen,
  resumeReviewOpen,
  onClose
}: ModalsProps) {
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  if (!getStartedOpen && !resumeReviewOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      onClose();
      setSubmitted(false);
      setStep(1);
    }, 2500);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-111">
      <div className="absolute inset-0 bg-navy-900/40 dark:bg-navy-900/80 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-112" />

      <div className="relative bg-white dark:bg-navy-800 w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200" data-id="element-113">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors z-10 bg-white/50 dark:bg-navy-800/50 rounded-full" data-id="element-114">
          <X size={20} data-id="element-115" />
        </button>

        {submitted ? <div className="p-10 text-center" data-id="element-116">
            <div className="w-16 h-16 bg-emerald-100 dark:bg-emerald-900/30 text-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-117">
              <CheckCircle2 size={32} data-id="element-118" />
            </div>
            <h3 className="font-heading font-bold text-2xl text-navy-900 dark:text-white mb-2" data-id="element-119">
              Request Received!
            </h3>
            <p className="text-slate-500 dark:text-slate-400" data-id="element-120">
              Our team will review your details and get back to you within 24
              hours.
            </p>
          </div> : <div className="p-6 sm:p-8" data-id="element-121">
            <h2 className="font-heading font-bold text-2xl text-navy-900 dark:text-white mb-2" data-id="element-122">
              {getStartedOpen ? 'Start Your Career Journey' : 'Get a Free Resume Review'}
            </h2>
            <p className="text-slate-500 dark:text-slate-400 text-sm mb-8" data-id="element-123">
              {getStartedOpen ? 'Tell us a bit about yourself and what you are looking to achieve.' : 'Upload your current resume and our experts will provide actionable feedback.'}
            </p>

            <form onSubmit={handleSubmit} className="space-y-5" data-id="element-124">
              {step === 1 && <div className="space-y-4 animate-in slide-in-from-right-4" data-id="element-125">
                  <div className="grid grid-cols-2 gap-4" data-id="element-126">
                    <div data-id="element-127">
                      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-128">
                        First Name
                      </label>
                      <input required type="text" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-brand/50 focus:border-brand outline-none transition-all" data-id="element-129" />
                    </div>
                    <div data-id="element-130">
                      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-131">
                        Last Name
                      </label>
                      <input required type="text" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-brand/50 focus:border-brand outline-none transition-all" data-id="element-132" />
                    </div>
                  </div>
                  <div data-id="element-133">
                    <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-134">
                      Email Address
                    </label>
                    <input required type="email" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-brand/50 focus:border-brand outline-none transition-all" data-id="element-135" />
                  </div>

                  {getStartedOpen && <div data-id="element-136">
                      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-137">
                        What services are you interested in?
                      </label>
                      <select className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-brand/50 focus:border-brand outline-none transition-all" data-id="element-138">
                        <option data-id="element-139">Resume Writing</option>
                        <option data-id="element-140">LinkedIn Optimization</option>
                        <option data-id="element-141">Cover Letter</option>
                        <option data-id="element-142">Career Coaching</option>
                        <option data-id="element-143">Full Package</option>
                      </select>
                    </div>}

                  <button type="button" onClick={() => setStep(2)} className="w-full bg-navy-900 dark:bg-brand hover:bg-navy-800 dark:hover:bg-brand-600 text-white py-3 rounded-xl font-medium transition-colors flex items-center justify-center gap-2 mt-2" data-id="element-144">
                    Continue <ChevronRight size={18} data-id="element-145" />
                  </button>
                </div>}

              {step === 2 && <div className="space-y-5 animate-in slide-in-from-right-4" data-id="element-146">
                  <div data-id="element-147">
                    <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-148">
                      Current Job Title
                    </label>
                    <input required type="text" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-brand/50 focus:border-brand outline-none transition-all" data-id="element-149" />
                  </div>

                  <div data-id="element-150">
                    <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-151">
                      Upload Current Resume (Optional)
                    </label>
                    <div className="border-2 border-dashed border-slate-200 dark:border-navy-600 rounded-xl p-8 text-center hover:bg-slate-50 dark:hover:bg-navy-900/50 transition-colors cursor-pointer group" data-id="element-152">
                      <div className="w-12 h-12 bg-brand-50 dark:bg-navy-800 text-brand rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform" data-id="element-153">
                        <Upload size={24} data-id="element-154" />
                      </div>
                      <p className="text-sm font-medium text-navy-900 dark:text-white mb-1" data-id="element-155">
                        Click to upload or drag and drop
                      </p>
                      <p className="text-xs text-slate-500 dark:text-slate-400" data-id="element-156">
                        PDF, DOCX up to 10MB
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-3 mt-4" data-id="element-157">
                    <button type="button" onClick={() => setStep(1)} className="px-6 py-3 rounded-xl font-medium border border-slate-200 dark:border-navy-600 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-navy-700 transition-colors" data-id="element-158">
                      Back
                    </button>
                    <button type="submit" className="flex-1 bg-brand hover:bg-brand-600 text-white py-3 rounded-xl font-medium transition-colors shadow-sm hover:shadow-md" data-id="element-159">
                      Submit Request
                    </button>
                  </div>
                </div>}
            </form>
          </div>}
      </div>
    </div>;
}